import { stem } from 'Components/Fonts/stem'

// stem.style.fontFamily already includes next/font's size-adjusted local
// fallback ('stem Fallback': Arial with ascent/descent/size-adjust matched
// to Stem, font-display swap) — the generic last resort must be sans-serif,
// not serif, so the pre-swap frame never flashes a serif face.
const fonts = {
  primary: `${stem.style.fontFamily}, sans-serif`,
}

export default fonts
